import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ namespace, type }) =>
    present(
      repository
        .getPrivateDocuments(namespace, type)
        .then((folder) => ({ namespace, type, folder }))
        .catch(() => Promise.reject({ namespace, type })),
    );
}

export type { Interactor };

export { createInteractor };
